import request from '@/utils/request'

export function loginInfo (query) {
  return request({
    url: '/user/loginInfo',
    method: 'get',
    params: query
  })
}

export function mlogin (query) {
  return request({
    url: '/user/Login',
    method: 'post',
    data: query
  })
}

export function bind (query) {
  return request({
    url: '/user/bindPhone',
    method: 'post',
    data: query
  })
}

export function sendCode (query) {
  return request({
    url: '/user/sendCode',
    method: 'get',
    params: query
  })
}

